module.exports = __webpack_public_path__ + "media/images/farey/carousel/demande_valorisation_gratuite-7ebf0ae92ae6eaa2007bb5735b24eb09.png";